import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addlocationpopup',
  templateUrl: './addlocationpopup.component.html',
  styleUrls: ['./addlocationpopup.component.css']
})
export class AddlocationpopupComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "Location";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  locationColl: any = [];
  locationBO: any = {};

  locationid: number = 0

  locationform = new FormGroup({
    locationid: new FormControl(0),
    locationname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  @Input() ischild: boolean = false;
  @Input() ischildadd: boolean = false;
  @Input() ischildkey: number = 0
  @Output() childChanged = new EventEmitter<number>();

  @Output() emitData = new EventEmitter();


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.locationform.reset();
      this.fnInitializeFormGroup();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.locationid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.locationform.setValue({
      locationid: 0,
      locationname: '',
      inactive: false
    })
  }




  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.locationform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'locationid': this.locationid,
          'locationname': this.locationform.get('locationname').value,
          'inactive': this.locationform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckLocation(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {

                //Insert 
                this.fnInsertLocation(data);

              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;
                  this.locationform.controls['locationname'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertLocation(data) {

    this.appService.fnInsertLocation(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          console.log(res.json())
          if (res.json().result != "") {
            // this.ischildkey = res.json().result[0].locationid;
            // this.ischildadd = true;
            this.toastr.success('', "The new location has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.locationname);
            var result = res.json().result;

            var locationid = 0;
            if (result.length > 0) {
              locationid = result[0].locationid
            }
            this.emitData.emit(locationid);
            this.activeModal.close(true);
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}






